import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7886c98d from 'nuxt_plugin_plugin_7886c98d' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_2a2ead81 from 'nuxt_plugin_plugin_2a2ead81' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_2167eb9c from 'nuxt_plugin_vuesocialsharingplugin_2167eb9c' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_axios_826dbfba from 'nuxt_plugin_axios_826dbfba' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_9a5bcf02 from 'nuxt_plugin_workbox_9a5bcf02' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_7a867092 from 'nuxt_plugin_metaplugin_7a867092' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_router_62b12028 from 'nuxt_plugin_router_62b12028' // Source: ./router.js (mode: 'all')
import nuxt_plugin_bugsnag_2200fd98 from 'nuxt_plugin_bugsnag_2200fd98' // Source: ../plugins/bugsnag.js (mode: 'all')
import nuxt_plugin_helpers_71cdfbe4 from 'nuxt_plugin_helpers_71cdfbe4' // Source: ../api/helpers.js (mode: 'all')
import nuxt_plugin_focus_5b3156fa from 'nuxt_plugin_focus_5b3156fa' // Source: ../directives/focus.js (mode: 'all')
import nuxt_plugin_index_7d2dd760 from 'nuxt_plugin_index_7d2dd760' // Source: ../filters/index.js (mode: 'all')
import nuxt_plugin_routerCustomclient_f32a4724 from 'nuxt_plugin_routerCustomclient_f32a4724' // Source: ../plugins/routerCustom.client.js (mode: 'client')
import nuxt_plugin_firebaseclient_5389411b from 'nuxt_plugin_firebaseclient_5389411b' // Source: ../plugins/firebase.client.js (mode: 'client')
import nuxt_plugin_vueobservevisibility_66676af7 from 'nuxt_plugin_vueobservevisibility_66676af7' // Source: ../plugins/vue-observe-visibility.js (mode: 'all')
import nuxt_plugin_matomoclient_4cc875f6 from 'nuxt_plugin_matomoclient_4cc875f6' // Source: ../plugins/matomo.client.js (mode: 'client')
import nuxt_plugin_vuexpersistclient_3ecc3f66 from 'nuxt_plugin_vuexpersistclient_3ecc3f66' // Source: ../plugins/vuex-persist.client.js (mode: 'client')
import nuxt_plugin_vuexsharedmutationsclient_2eeac0b6 from 'nuxt_plugin_vuexsharedmutationsclient_2eeac0b6' // Source: ../plugins/vuex-shared-mutations.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Aire de jeux publiques gratuites pour les enfants","meta":[{"hid":"charset","charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"apple-touch-startup-image","content":"\u002Fimg\u002Floading-1s.svg"},{"name":"theme-color","content":"#1e0037","media":"(prefers-color-scheme:light)"},{"name":"theme-color","content":"#0d0217","media":"(prefers-color-scheme:dark)"},{"hid":"description","name":"description","content":"Annuaire complet des aires de jeux publiques gratuites pour les enfants"},{"hid":"image","property":"image","content":"https:\u002F\u002Fadj.info\u002Fimg\u002Fsocials\u002Fdefault-small.jpg"},{"hid":"og:title","property":"og:title","content":"Aire de jeux publiques gratuites pour les enfants"},{"hid":"og:description","name":"og:description","content":"Annuaire complet des aires de jeux publiques gratuites pour les enfants"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fadj.info\u002Fimg\u002Fsocials\u002Fdefault-small.jpg"},{"hid":"twitter:card","property":"twitter:card","content":"summary"},{"hid":"twitter:title","property":"twitter:title","content":"Aire de jeux publiques gratuites pour les enfants"},{"hid":"twitter:description","name":"twitter:description","content":"Annuaire complet des aires de jeux publiques gratuites pour les enfants"},{"hid":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fadj.info\u002Fimg\u002Fsocials\u002Fdefault-small.jpg"}],"noscript":[{"innerHTML":"Nous sommes désolés mais Aire de jeux ne fonctionne pas correctement sans JavaScript. Veuillez s'il vous plaît l'activer pour continuer.","body":true}],"__dangerouslyDisableSanitizers":["noscript"],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fimg\u002Flogos\u002Ffavicon-16x16.png"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7886c98d === 'function') {
    await nuxt_plugin_plugin_7886c98d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2a2ead81 === 'function') {
    await nuxt_plugin_plugin_2a2ead81(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_2167eb9c === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_2167eb9c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_826dbfba === 'function') {
    await nuxt_plugin_axios_826dbfba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_9a5bcf02 === 'function') {
    await nuxt_plugin_workbox_9a5bcf02(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_7a867092 === 'function') {
    await nuxt_plugin_metaplugin_7a867092(app.context, inject)
  }

  if (typeof nuxt_plugin_router_62b12028 === 'function') {
    await nuxt_plugin_router_62b12028(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_2200fd98 === 'function') {
    await nuxt_plugin_bugsnag_2200fd98(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_71cdfbe4 === 'function') {
    await nuxt_plugin_helpers_71cdfbe4(app.context, inject)
  }

  if (typeof nuxt_plugin_focus_5b3156fa === 'function') {
    await nuxt_plugin_focus_5b3156fa(app.context, inject)
  }

  if (typeof nuxt_plugin_index_7d2dd760 === 'function') {
    await nuxt_plugin_index_7d2dd760(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routerCustomclient_f32a4724 === 'function') {
    await nuxt_plugin_routerCustomclient_f32a4724(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_firebaseclient_5389411b === 'function') {
    await nuxt_plugin_firebaseclient_5389411b(app.context, inject)
  }

  if (typeof nuxt_plugin_vueobservevisibility_66676af7 === 'function') {
    await nuxt_plugin_vueobservevisibility_66676af7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_matomoclient_4cc875f6 === 'function') {
    await nuxt_plugin_matomoclient_4cc875f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersistclient_3ecc3f66 === 'function') {
    await nuxt_plugin_vuexpersistclient_3ecc3f66(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexsharedmutationsclient_2eeac0b6 === 'function') {
    await nuxt_plugin_vuexsharedmutationsclient_2eeac0b6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
